import { t } from '@lingui/core/macro';
import type { IncompleteReason } from '@duke-hq/svc-api/lib/assessment/incompleteSlides';

export function incompleteSlideLabel(reason: IncompleteReason): string {
  switch (reason) {
    case 'FORM_NO_FIELDS':
      return t`Form has no fields`;
    case 'QUESTION_GROUP_NO_QUESTIONS':
      return t`Question group has no questions`;
  }
}
